module.exports = __webpack_public_path__ + "img/nodata_joy.185d268d.png";